import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import {
  validateNumber,
  validatePresence,
} from 'ember-changeset-validations/validators';
import AbilitiesService from 'donor-elf-web/services/abilities';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';

const VALIDATION = {
  annualGoal: [
    validatePresence({ presence: true, message: "Can't be blank" }),
    validateNumber({ gte: 1, message: 'Must be a positive number' }),
  ],
};

export default class FundGoalAnnualRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('edit_goal')) {
      transition.abort();
    }
  }

  async model() {
    let record = (await this.store.query('annual-fund-goal', {})).slice()[0];
    if (record) {
      this.navbarSettings.title = 'Edit Annual Goal';
    } else {
      this.navbarSettings.title = 'Add Annual Goal';
      record = this.store.createRecord('annual-fund-goal');
    }
    let changeset = Changeset(
      record,
      lookupValidator(VALIDATION),
      VALIDATION,
    );
    return {
      changeset,
    };
  }
}
